// Independent Variables (input-only)
export const Length = 0;
export const Width = 1;
export const Height = 2;

// Dependent Variables (input-output)
export const Material = 0;
export const Density = 1;
export const Volume = 2;
export const Surface_Area = 3;
export const VolToSurfArea = 4;
export const Girth = 5;
export const Length_Girth = 6;
export const Diagonal = 7;
export const Weight = 8;